import { subdomains } from "@/common/consts";
import ExamplesHome from "@/pages/Examples/Home/ExamplesHome.vue";
import ExamplesDetail from "@/pages/Examples/Detail/ExamplesDetail.vue";
import ExperimentOverride from "@/pages/ExperimentOverride/ExperimentOverride.vue";

export default [
    {
        path: "/",
        name: "ExamplesHome",
        meta: {
            subdomain: subdomains.EXAMPLES
        },
        component: ExamplesHome
    },
    {
        path: "/abexp/:channel?",
        name: "ExperimentOverride",
        component: ExperimentOverride
    },
    {
        path: "/*",
        name: "ExamplesDetail",
        meta: {
            subdomain: subdomains.EXAMPLES
        },
        component: ExamplesDetail
    }
];



// WEBPACK FOOTER //
// ./src/router/routes/subdomain.examples.js